import {CSSProperties} from "react";
import {Link} from "react-router";
import {Badge} from "@/components/ui/badge.tsx";
import {cn} from "@/lib/utils.ts";
import CharacterImage from "@/characters/CharacterImage.tsx";
import {CharacterSummary} from "@/characters/model/Character.ts";
import {formatChallengeRating, getStyleColor} from "@/characters/model/ChallengeRating.ts";

export default function CharacterListItem({character, href, search, selected, style}: {
    character: CharacterSummary;
    href: string;
    search: string;
    selected: boolean;
    style?: CSSProperties;
}) {
    const color = getStyleColor(character);
    return (
        <div style={style} className="border-b border-border bg-surface">
            <Link className={cn(
                "flex h-full items-center border-l-2 border-transparent p-1 transition-colors hover:bg-accent/65",
                selected && "border-l-warning bg-warning/10",
            )} to={{pathname: href, search}}>
                <CharacterImage character={character} size={32}/>
                <span className="grow truncate px-3 font-medium text-foreground">{character.name}</span>
                <Badge className={cn("border text-xs", color.bg, color.text, color.border)}>
                    HG {formatChallengeRating(character)}
                </Badge>
            </Link>
        </div>
    );
}
